import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class PasswordResetFinish {

    constructor (private http: HttpClient) {}

    save(keyAndPassword: any): Observable<any> {
        return this.http.post('/api/account/reset-password/finish', keyAndPassword);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/password-reset/finish/password-reset-finish.service.ts